import { DatePivotParams } from "../../entities/date_pivot_params";

export const defaultConfig: DatePivotParams = {
  // Inert here (no DatePeriodPicker, dateHierarchyColumnFilter is null) — this view
  // is a point-in-time position, not a time series.
  dateHierarchy: "last_receipt_date",
  measure: "",
  // Default to SKU grain: the useful question is which items are stranded and for how
  // long. Deselecting "SKU" collapses to one row per location for a quick zero-check.
  segments: ["sku"],
  minDate: null,
  maxDate: null,
  filters: [],
  postFilters: [],
};
